import React, {Fragment, useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card, Row, Col, Form} from 'react-bootstrap'
import Nav from "react-bootstrap/Nav";
import {getLabels, getReports, postReport, deleteReport, getHospital} from '../../../actions'
import {connect} from "react-redux";
import ReportItem from "./ReportItem";
import {Route, NavLink, useNavigate} from "react-router-dom";
import {ConfirmDeleteModal, HospitalData, UserUploadDataComponent} from "./index";
import {updateValues,clearError} from "../../../actions/BasicActions";
import Spinner from "../../common/Spinner";
import AddReport from "./AddReport";
import Container from "react-bootstrap/Container";
import {Button, FormGroup, Input, Label, Modal} from 'reactstrap'
// import Modal from "react-bootstrap/Modal";
import ReportList from "./ReportList";
import ReportModal from "./ReportModal";

const UserReports = ({Basic: {reports, hospital,error}, PlotData: {labels}, updateValues, deleteReport,clearError, postReport}) => {
    const [data, setData] = useState(null);
    const [newReport, SetNewRaport] = useState({
        "data_od": "2020-01-01",
        "data_do": "2021-01-01",
        "rachunek_zyskow": {},
        "bilans": {},
        "rachunek_przeplywu": {},


    });
    const [modalShow, setModalShow] = useState(false)
    const [labelsSplited, setLabels] = useState(labels);
    const [activeReportID, setActive] = useState('add');
    const [showError,setShowError] =  useState(false);
    const [showReport,setShowReport] = useState(false)
    useEffect(() => {
        if(error)
            setShowError(true);
        else
            setShowError(false);

    },[error])
    const navigate = useNavigate();

    const Save = (newValues, name) => {
        Object.assign(data[name], newValues);
        updateValues(data)

    };

    const AddDataToNewRaport = (name, newReportData, save) => {
        if (typeof newReportData === "string") {
            SetNewRaport({...newReport, [name]: newReportData})
        } else {
            Object.assign(newReport[name], newReportData);
            SetNewRaport(newReport);
        }


        if (save) {
            postReport(newReport)
            navigate("/admin/yourData/reports/1")
            setData(null)
            SetNewRaport({
                "data_od": "2020-01-01",
                "data_do": "2021-01-01",
                "rachunek_zyskow": {},
                "bilans": {},
                "rachunek_przeplywu": {},
            })
            setActive("add")
        }

    };
    useEffect(() => {
        if (newReport != null && hospital != null) {
            SetNewRaport({...newReport, "szpital": hospital.id})
        }
    }, [newReport.szpital]);
    useEffect(() => {
        setLabels(labels)
    }, [labels])
    const deleteActiveReport = () => {
        if(activeReportID) {
            deleteReport(activeReportID)
            setActive(null)
        }
    };
    const setReport = (id) =>{
        setActive(id)
        setData(reports.filter(report=> report.id === id)[0])
        setShowReport(true)
    }
    return (
        <Fragment>
             <ConfirmDeleteModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            deleteReport={deleteActiveReport}
                        />
            <Row md={12}>
                <UserUploadDataComponent/>

            </Row>

            <Row>
                <ReportList Reports={reports} setReport={setReport} setActive={setActive} deleteReport={setModalShow}/>
            </Row>


            <ReportModal onHide={setShowReport} show={showReport} activeReportID={activeReportID} setModalShow={setModalShow} modalShow={modalShow} Save={Save} data={data} deleteActiveReport={deleteActiveReport} labelsSplited={labelsSplited} />

            <Modal  isOpen={showError}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
                   style={{opacity:1}}
            >
              <div className="modal-header">
                <h5 id="contained-modal-title-vcenter">
                    {error ==="Pomyślnie dodano sprawozdanie"?"Sukces!":"Błędne sprawozdanie!"}

                </h5>
              </div>
              <div className="modal-body">
                <FormGroup className="pb-2 justify-content-md-center" check>
                  <Label>
                      {error}
                  </Label>
              </FormGroup>
              </div>
              <div className="modal-footer" >
                <Button onClick={clearError} className='btn-link' type='button' style={{width:"100%",  margin:"5px"}} color='wskazniki'>Ok</Button>
              </div>
            </Modal>
        </Fragment>
    )
};



const mapStateToProps = state => ({
    Basic: state.Basic,
    PlotData: state.PlotData

});
export default connect(mapStateToProps, {
    getReports,
    getLabels,
    updateValues,
    getHospital,
    deleteReport,
    postReport,
    clearError
})(UserReports)